/**
 * Created by tigran on 18.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const SurveyTemplatesIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.7893 2.75293L4.64648 2.75293L4.64648 21.6101L21.7893 21.6101L21.7893 2.75293Z"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M2.93237 12.1815H6.36094"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M2.93237 7.89581L6.36094 7.89581"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M2.93237 16.4672H6.36094"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M17.5036 9.61011L10.6465 9.61011L10.6465 14.753L17.5036 14.753V9.61011Z"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
    </svg>
  );
};
